import * as Types from '../types';
import { AnyAction, Dispatch } from 'redux';

export const InviteNew =
  (inviteNew: boolean) =>
  async (dispatch: Dispatch<AnyAction>): Promise<void> => {
    dispatch({
      payload: inviteNew,
      type: Types.DataIntegrationTypes.UPDATE_INVITE_NEW,
    });
  };
